const BACKEND_URL ='https://ufb-1.onrender.com'


export default BACKEND_URL;